import React from "react";

export default function PageTitle({ title, fontProps = 'default' }) {
    return (
        <div className="w-full min-h-24 bg-[#164481] bg-contain bg-no-repeat bg-top pt-36 md:pt-56">
            <div className="relative">
                <div className="container mx-auto 2xl:px-0 md:px-14 px-8">
                    {fontProps === 'default' ? 
                    <h1 className="md:text-4xl text-2xl font-evil font-bold italic uppercase text-white">
                            {title}
                        </h1> : <h1 className="md:text-4xl text-2xl font-poppins font-bold italic uppercase text-white">
                            {title}
                        </h1>}
                </div>
            </div>
        </div>
    );
}
